import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quote-square-close",
  "use": "icon-quote-square-close-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 12\" id=\"icon-quote-square-close\">\r\n<path id=\"icon-quote-square-close__x201C_-copy\" d=\"M16,0v6.4L13.3,12h-3.3l1.3-5.3H9V0H16z M7,0v6.4L4.3,12H1.1l1.3-5.3H0V0H7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/quote-square-close.svg
// module id = 306
// module chunks = 0 1